import { Component, OnInit, ViewChild } from '@angular/core';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/mcplanningmaterial.service'
import { FinalRequirementDetails, RequirementDetailsZMH } from 'src/app/Models/MCPlanningMaterial/mcplanningmaterial';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component'
import { DropDownResponse } from 'src/app/Models/Dashboard/DashboardFilters';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-zmh-requirementapproval',
  templateUrl: './zmh-requirementapproval.component.html',
  styleUrls: ['./zmh-requirementapproval.component.css'],
  providers: [DatePipe]
})
export class ZmhRequirementapprovalComponent implements OnInit {
  @ViewChild('jobnumber') jobnumber;
  @ViewChild('brand') brand;
  @ViewChild('crop') crop;
  @ViewChild('jobtype') jobtype;
  @ViewChild('language') language;
  @ViewChild('rmh') rmh;
  @ViewChild('status') status;
  @ViewChild('year') year;

 // @ViewChild('ma') ma;
  public jobNumberSettings = {};
  public brandSettings = {};
  public cropSettings = {};
  public jobTypeSettings = {};
  public languageSettings = {};
  public rmhSettings = {};
  public statusSettings = {};
  public yearSettings = {};

  requirementId: string = '';
  public JobNumbers :any=[];
  selectCheck: boolean = false;
  IsDisabled : boolean ;
  loader: string = 'none';
  userID: string;
  roleID: string;
  selectedJobNumber: any = '';
  selectedRMHName: any = '';
  selectedJobType: any = '';
  selectedBrand: any = '';
  selectedCrop: any = '';
  selectedLanguage: any = '';
  selectedStatus: any = '';
  selectedYear: any = '';
  accessdata:string='';// add by deepanshu 5 june 2023
  requirementdetails:RequirementDetailsZMH[]=[];
  public ddlResponse: DropDownResponse = new DropDownResponse();
 
  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private router: Router, private snackBar: MatSnackBarComponent,private datepipe: DatePipe,private toastr: ToastrService) { 
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getFiltersOnPageLoad();
    this.jobNumberSetting();
    this.brandSetting();
    this.cropSetting();
    this.languageSetting();
    this.statusSetting();
    this.jobTypeSetting();
    this.rmhSetting();
    this.yearSetting();
   this.GetRequirementDetails();
  }
  getFiltersOnPageLoad() {
     this.loader = 'block';
    this.mcPlanningMaterialService.getRequirementDetailsFiltersZMH()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          //this.dashboardFilters = resData.data as DashboardFilters;
          this.ddlResponse = resData.data;
          this.accessdata=resData.data.access[0].access; //add by deepanshu 5 june
        //  alert(this.accessdata);//add by deepanshu 5 june
          this.onCurrentRequirementYearSelected(this.ddlResponse.year)
          //this.ddlResponse.brands=resData.data;

          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }
  public onCurrentRequirementYearSelected(item: any) {
    class YearItemList{
      id: number;
      text: string;
  }
    let requiredItem: YearItemList[] = [];
    var obj = {
      id : item[0].currentrequirementYear,
      text: item[0].currentrequirementYear
    }
    requiredItem.push(obj)
    this.year.selectedItems=requiredItem
    for (var i = 0; i < this.year.selectedItems.length; i++) {
      this.selectedYear.push(this.year.selectedItems[i].text)
    }
    this.yearSetting();
  }

  GetRequirementDetails() {
    this.selectedRMHName="";
    this.selectedCrop="";
    this.selectedBrand="";
    this.selectedJobType="";
    this.selectedLanguage="";
    this.selectedStatus="";
    this.selectedJobNumber="";
    this.selectedYear = "";

    this.mcPlanningMaterialService.GetRequirementDetailsZMH(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.selectedStatus, this.selectedJobNumber,this.selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          debugger;
          this.requirementdetails = responseData.data;
          this.loader = 'none';
        }
        else {
          this.requirementdetails = responseData.data;
          this.toastr.error('No records Available');
          this.loader = 'none';
        }
      })
  
  }
  filter() {
    let selectedJobnumber = '';
    let selectedRMH = '';
    let selectedBrand = '';
    let selectedCrop = '';
    let selectedJobtype = '';
    let selectedLanguage = '';
    let selectedStatus = '';
    let selectedYear = '';
  
    selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    selectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    selectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    selectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    
    this.mcPlanningMaterialService.GetRequirementDetailsZMH(selectedRMH, selectedJobtype, selectedBrand, selectedCrop, selectedLanguage,selectedStatus, selectedJobnumber,selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          this.requirementdetails = responseData.data;
          this.loader = 'none';
        }
        else {
          this.requirementdetails = responseData.data;
          this.toastr.error('No records Available');
          this.loader = 'none';
        }
      })
  
  }
  checkSelected(index: number) {
       if (!this.requirementdetails[index]["isActive"]&&this.requirementdetails[index]["isDisable"]==false) {
     // this.JobNumbers.splice(index,1);
      this.JobNumbers.splice(this.JobNumbers.indexOf(this.requirementdetails[index].jobNumber), 1);
          
    }
    else
    this.JobNumbers.push(this.requirementdetails[index]["jobNumber"]);
  }
  // check(index: any) {
  //   if(this.requirementdetails[index]["isActive"])
  //   {
  //     return 'true'
  //   }
  //   else{
  //     'false'
  //   }
  // }
  ApproveRequirement()
  {
    this.mcPlanningMaterialService.ApproveRequirement(this.JobNumbers)
    .subscribe((responseData: any) => {
      if (responseData.status) {
        this.toastr.success(responseData.message);
        this.loader = 'none';
        this.selectCheck=false;
        this.filter();
      }
      else {
        this.toastr.error('Some error Occured,Could not update status');
        this.loader = 'none';
        this.filter();
      }
    })
  }
  SelectAll() {
    this.JobNumbers=[];
    if(this.selectCheck==true)
    {
    this.requirementdetails.forEach(element => {
      this.JobNumbers.push(element.jobNumber);
      element.isActive = true;
    })
  }
  else{
    this.requirementdetails.forEach(element => {
         element.isActive = false;
    })
  }
  }
  // onJobNumberSelect(item: any) {
  //       this.getJobnumberWiseData(this.jobnumber.selectedItems);
   
  // }
  // onJobNumberSelectAll(item: any) {
    
  //   this.getJobnumberWiseData(this.jobnumber.selectedItems);
    
  // }
  // onJobNumberDeSelect(item: any) {
  //   this.getJobnumberWiseData(this.jobnumber.selectedItems);
  //   if (this.jobnumber.selectedItems.length == 0) {
  //     this.jobnumber.selectedItems = [];
  //     this.brand.selectedItems = [];
  //     this.crop.selectedItems = [];
  //     this.jobtype.selectedItems = [];
  //     this.language.selectedItems = [];
  //     if (this.roleID != '42') {
  //       this.rmh.selectedItems = [];
  //     }
  //     if (this.roleID != '42' && this.roleID != '48') {
  //       this.ma.selectedItems = [];
  //     }
  //     this.requirementType.selectedItems = [];
  //     this.status.selectedItems = [];
  //   }
  // }
  onJobNumberDeSelectAll(item: any) {

      this.jobnumber.selectedItems = [];
      // this.brand.selectedItems = [];
      // this.crop.selectedItems = [];
      // this.jobtype.selectedItems = [];
      // this.language.selectedItems = [];
      // this.rmh.selectedItems = [];
      // this.status.selectedItems = [];
    }
  
  
  // onRMHDeSelect(item: any) {
   
  //   this.rmh.selectedItems = [];
  // }
  onRMHDeSelectAll(item: any) {
   
    this.rmh.selectedItems = [];
  }
  // onRMHSelect(item: any) {

  //   this.getRMHWiseData(this.rmh.selectedItems);

  // }
  // onRMHSelectAll(item: any) {
  //   this.getRMHWiseData(this.rmh.selectedItems);

  // }

 
  // onbrandSelect(item: any) {
  //   this.getbrandWiseData(this.brand.selectedItems);
  // }
  // onbrandSelectAll(item: any) {
  //   this.getbrandWiseData(this.brand.selectedItems);
  // }
  // onbrandDeSelect(item: any) {
  //   if (this.brand.selectedItems.length < 1) {
  //     this.brand.selectedItems = [];
  //     this.crop.selectedItems = [];
  //     this.jobtype.selectedItems = [];
  //     this.language.selectedItems = [];
  //   }
  //   else
  //     this.getbrandWiseData(this.brand.selectedItems);
  // }
  // onbrandDeSelectAll(item: any) {
  //   this.brand.selectedItems = [];
  //   this.crop.selectedItems = [];
  //   this.jobtype.selectedItems = [];
  //   this.language.selectedItems = [];
  // }

  jobNumberSetting() {
    this.jobNumberSettings = {
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Job Number Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  brandSetting() {
    this.brandSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Brand Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  cropSetting() {
    this.cropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Crop Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  jobTypeSetting() {
    this.jobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No JobType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  languageSetting() {
    this.languageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Language Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  rmhSetting() {
    this.rmhSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  yearSetting() {
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  
  statusSetting() {
    this.statusSettings = {
      singleSelection: false,
      idField: 'requirementStatusID',
      textField: 'requirementStatusName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  excelDownload(){
      this.loader = 'block';
      let selectedJobnumber = '';
      let selectedRMH = '';
      let selectedBrand = '';
      let selectedCrop = '';
      let selectedJobtype = '';
      let selectedLanguage = '';
      let selectedStatus = '';
      let selectedYear = '';
    
      selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
      selectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
      selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
      selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
      selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
      selectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
      selectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
      selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");

      this.mcPlanningMaterialService.GetAnnualRequirementDetailForZMHApprovalExcel(selectedRMH, selectedJobtype, selectedBrand, selectedCrop, selectedLanguage, selectedStatus, selectedJobnumber,selectedYear)
        .subscribe(
          success => {
            var date = new Date();
            let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
            let name = localStorage.getItem('mcmt_userName').split(' ');
            let firstname = name[0];
            let lastName = name[1];
            //let roleId=localStorage.getItem('mcmt_roleID');
            let cYear = this.year.selectedItems[0].id;
            let excelName = firstname + '_' + lastName + '_'+ cYear + '_AnnualRequirementApproval_' + latest_date + '.xlsx';
            saveAs(success, excelName);
            this.loader = 'none';
          },
          err => {           
                this.toastr.error("No Record/s Available");
            this.loader = 'none';
          }
        );
    
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
